import React from 'react';
import ErrorIcon from '../../icons/error2.svg';
import BackButton from '../parcel-finder/claims/common/BackButton';
import Link from '../common/Link';
import PlainButton from '../common/PlainButton';
import Locale from '../Translate/Locale';
import BackIcon from '../../icons/arrow-left.svg';

import styles from './ErrorContainer.scss';

interface ErrorContainerProps {
  text: string;
  buttonLink?: string;
}

function ErrorContainer({ text, buttonLink }: ErrorContainerProps) {
  return (
    <div className={styles.errorContainer} data-test-id="error-container">
      <ErrorIcon className={styles.icon} />
      <p className={styles.error}>
        <Locale>{text}</Locale>
      </p>
      {buttonLink && (
        <Link to={buttonLink}>
          <PlainButton icon={BackIcon}>Back</PlainButton>
        </Link>
      )}
    </div>
  );
}

export default ErrorContainer;
